import { fetchProducts } from "./api";
import { getStoredIds } from "./storage";
import { renderEmptyState, renderErrorState, renderTable } from "./render";
import { initContextMenu } from "./contextMenu";
import { initCompareConfirm } from "./confirmModal";
import { refreshDifferencesState } from "./differences";

export const compareTable = async () => {
  const container = document.querySelector("[data-table]");

  if (!container) {
    return;
  }

  const render = async () => {
    const ids = getStoredIds();

    if (!ids.length) {
      renderEmptyState(container);
      return;
    }

    try {
      const products = await fetchProducts(ids);

      if (!products.length) {
        renderEmptyState(container);
        return;
      }

      renderTable(container, products);
      refreshDifferencesState();
    } catch (error) {
      renderErrorState(container);
      console.error(error);
    }
  };

  initContextMenu({
    onRemove: render,
  });

  initCompareConfirm({
    onConfirm: render,
  });

  await render();
};